/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Quickview and Wishlist loading fixed
jQuery(document).ready(function() {
  if (typeof window.isInWishlist !== "function") {
    window.isInWishlist = function() { return false; };
  }

  jQuery("a[href='/apps/iwish']").click(function(e) {
    if(typeof(Storage) !== "undefined") {
      e.preventDefault();
      iWishPost('/apps/iwish',{iwishlist:JSON.stringify(iWishlistmain),cId:iwish_cid});
    }
  });

  jQuery(document).on("click", ".iWishAddColl", function(e) {
    e.preventDefault();
    var iWishvId = jQuery(this).attr("data-variant");
    if (typeof iwish_addCollection === "function") {
      iwish_addCollection(jQuery(this), iWishvId);
    }
    return false;
  });

  iwishCheckColl();
});

function iwishCheckColl(){
  if(jQuery(".iwishcheck").length > 0) {
    jQuery(".iwishcheck").each(function() {
      var $this = jQuery(this);
      var iWishvId = $this.attr("data-variant");
      var iWishpId = $this.attr("data-product");
      
      try {
        if(typeof isInWishlist === "function" && isInWishlist(iWishpId, iWishvId)){ 
          $this.addClass("iwishAdded").html(iwish_added_txt_col); 
        }
      } catch(e) {
        console.log("Wishlist check failed for product: " + iWishpId);
      }
      $this.removeClass("iwishcheck");
    });
  }
}
// Quickview and Wishlist loading fixed



// jQuery( document ).ready(function() {
// 	jQuery("a[href='/apps/iwish']").click(function(e) {
// 		if(typeof(Storage) !== "undefined") {
// 			e.preventDefault();
// 			iWishPost('/apps/iwish',{iwishlist:JSON.stringify(iWishlistmain),cId:iwish_cid});
// 		}
// 	});
// 	jQuery(".iWishAdd").click(function() {
// 		var iWishvId = jQuery(this).parents(iwishWrapperClass).find(iWishVarSelector).val();
// 		iwish_add(jQuery(this), iWishvId);
// 		return false;
// 	});
// 	jQuery(".iWishAddColl").click(function() {
// 		var iWishvId = jQuery(this).attr("data-variant");
// 	       	iwish_addCollection(jQuery(this),iWishvId);
// 	      	return false;
// 	});
// 	iwishCheckColl();
// });
// function iwishCheckColl(){
// 	if(jQuery(".iwishcheck").length > 0) {
// 	jQuery(".iwishcheck").each(function() {
// 		console.log('iWishvId: '+ iWishpId);
// 		var iWishvId = jQuery(this).attr("data-variant");
// 		var iWishpId = jQuery(this).attr("data-product");
// 		if(isInWishlist(iWishpId,iWishvId)){ jQuery(this).addClass("iwishAdded").html(iwish_added_txt_col); }
// 		jQuery(this).removeClass("iwishcheck");
// 	});
// 	}
// }




// Insert any custom theme js here...

/**
 * Javascript-Equal-Height-Responsive-Rows
 */

!function(i){"use strict";i.fn.equalHeight=function(){var e=[];return i.each(this,function(t,r){var s,n=i(r),a="border-box"===n.css("box-sizing")||"border-box"===n.css("-moz-box-sizing");s=a?n.innerHeight():n.height(),e.push(s)}),this.css("height",Math.max.apply(window,e)+"px"),this},i.fn.equalHeightGrid=function(e){var t=this.filter(":visible");t.css("height","auto");for(var r=0;r<t.length;r++)if(r%e===0){for(var n=i(t[r]),s=1;e>s;s++)n=n.add(t[r+s]);n.equalHeight()}return this},i.fn.detectGridColumns=function(){var e=0,t=0,r=this.filter(":visible");return r.each(function(r,n){var s=i(n).offset().top;return 0!==e&&s!==e?!1:(t++,void(e=s))}),t};var e=0;i.fn.responsiveEqualHeightGrid=function(){function n(){var i=t.detectGridColumns();t.equalHeightGrid(i)}var t=this,r=".grids_"+e;return t.data("grids-event-namespace",r),i(window).bind("resize"+r+" load"+r,n),n(),e++,this},i.fn.responsiveEqualHeightGridDestroy=function(){var e=this;return e.css("height","10"),i(window).unbind(e.data("grids-event-namespace")),this}}(window.jQuery);

$(window).on('load resize ready', function() {
 getEqualHeightGrid();
 setTimeout(function(){
   getEqualHeightGrid();
 }, 1000);
 setTimeout(function(){
   getEqualHeightGrid();
 }, 2000);
 setTimeout(function(){
   getEqualHeightGrid();
 }, 3000);
 setTimeout(function(){
   getEqualHeightGrid();
 }, 4000);
 setTimeout(function(){
   getEqualHeightGrid();
 }, 5000);
});
function getEqualHeightGrid() {
 $('.product__details').responsiveEqualHeightGrid();
 $('.product__title.h4').responsiveEqualHeightGrid();
}

function adjustTheEssentials(){
  if( $( window ).width() >= 600 ){
    $('.collection_left .home-intro__media-img').height($('.home-custom-section-coll .collection_right_top').height()+$('.home-custom-section-coll .collection_right_bottom .home-intro__media-img').height())
  } else {
    $('.collection_left .home-intro__media-img').height('auto');
  }
}

$( window ).resize(function(){
  adjustTheEssentials();
});


$('.home-custom-section-coll .home-intro__media-img').each(function() {
  if( this.complete ) {
      adjustTheEssentials();
  } else {
      $(this).one('load', adjustTheEssentials);
  }
});
$('.product-single__accordion').delay(1000).show(0);


//document.onreadystatechange = function() { 
//            if (document.readyState !== "complete") { 
//                document.querySelector( 
//                  "body").style.visibility = "hidden"; 
//                document.querySelector( 
//                  "#loader").style.visibility = "visible"; 
//            } else { 
//                document.querySelector( 
//                  "#loader").style.display = "none"; 
//                document.querySelector( 
//                  "body").style.visibility = "visible"; 
//            } 
//        };


function whenJQueryIsReady(callback) {
    if (typeof window.jQuery !== 'undefined') {
        callback(window.jQuery);
    } else {
        setTimeout(function() {
            whenJQueryIsReady(callback);
        }, 50);
    }
}

whenJQueryIsReady(function($) {
    function handleize(str) {
        return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    var filterThumbnails = function(variant) {
        console.log("thumbnail updated", variant);

        $('[data-thumbnail-color]').hide();

        if (variant && variant.featured_image && variant.featured_image.alt) {
            var selected_color = handleize(variant.featured_image.alt);
            var thumbnail_selector = '[data-thumbnail-color="' + selected_color + '"]';
            $(thumbnail_selector).show();
        } else {
            $('[data-thumbnail-color]').show();
        }
    };

    $(document).ready(function() {
        var productJSON = document.querySelector('[type="application/json"][data-product-json]');
        if (productJSON) {
            var productData = JSON.parse(productJSON.textContent);
            var firstVariant = productData.variants[0];
            if (firstVariant) {
                filterThumbnails(firstVariant);
            }
        }
    });
});